import "./FeedbackPostList.css";
import { FeedbackPostDTO } from "../../types/FeedbackPostDTO";
import FeedbackPost from "../FeedbackPost/FeedbackPost";
import { RefreshCcw } from "lucide-react";

interface Props {
  posts: FeedbackPostDTO[];
  variant: "default" | "manager";
  onLike: (postId: number) => void;
  onComplete?: (postId: number) => void;
  showCompleted?: boolean;
  setShowCompleted?: (show: boolean) => void;
  refreshPosts?: () => void;
}

function FeedbackPostList({
  posts,
  variant,
  onLike,
  onComplete,
  showCompleted,
  setShowCompleted,
  refreshPosts,
}: Props) {
  return (
    <>
      <div className="feedback-title-container">
        <h2 className="feedback-title">
          {showCompleted ? "Alle" : "Offene"} Feedbacks ({posts.length})
        </h2>

        <div className="feedback-list-actions">
          {variant === "manager" && setShowCompleted && (
            <button
              className="feedback-action-button toggle-show"
              onClick={() => setShowCompleted && setShowCompleted(!showCompleted)}
            >
              {showCompleted ? "Nur Offene" : "Alle"}
            </button>
          )}
          <button className="feedback-action-button refresh" onClick={refreshPosts}>
            <RefreshCcw size={20} />
          </button>
        </div>
      </div>

      {posts.length === 0 && <p className="feedback-empty">Keine Feedbacks gefunden.</p>}

      {posts.map((post) => (
        <FeedbackPost
          key={post.id}
          post={post}
          variant={variant}
          onLike={onLike}
          onComplete={onComplete}
        />
      ))}
    </>
  );
}

export default FeedbackPostList;
